const I18n = require("./I18n");

class FormErrors {
  constructor(errors, i18nScope) {
    this._i18nScope = i18nScope;
    this._ownErrors = [];
    this._nestedErrors = {};

    switch(Object.prototype.toString.call(errors)) {
      case "[object Array]":
        this._ownErrors = errors;
        break;
      case "[object Object]":
        if (errors.errors !== undefined) {
          this._ownErrors = errors.errors.slice();
        }
        this._nestedErrors = errors;
        break;
      default:
        // ignore
    }

    return this;
  }

  get(name, i18nSubscope) {
    let nextI18nScope = this._i18nScope;
    if (i18nSubscope === undefined) {
      nextI18nScope += `.${name}`;
    } else if (i18nSubscope != "") {
      nextI18nScope += `.${i18nSubscope}`;
    }
    if (this._nestedErrors.hasOwnProperty(name)) {
      return new FormErrors(this._nestedErrors[name], nextI18nScope);
    } else {
      return new FormErrors();
    }
  }

  firstError() {
    const first = this._ownErrors[0];
    if (first !== undefined) {
      return I18n.t(`${this._i18nScope}.${first}`);
    }
    return undefined;
  }

  hasAny() {
    return this.firstError() !== undefined;
  }

  remove(name) {
    if (this._nestedErrors.hasOwnProperty(name)) {
      delete this._nestedErrors[name];
    }
  }
}

module.exports = FormErrors;



// WEBPACK FOOTER //
// ./app/javascript/helpers/FormErrors.js